"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getReducers = getReducers;
exports.registerReducer = registerReducer;
exports.unRegisterReducer = unRegisterReducer;
exports.setChangeListener = setChangeListener;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _emitChange = null;
var _reducers = {};

function getReducers() {
  return _objectSpread({}, _reducers);
}

function registerReducer(name, reducer) {
  _reducers = _objectSpread({}, _reducers, (0, _defineProperty2["default"])({}, name, reducer));

  if (_emitChange) {
    _emitChange(getReducers());
  }
}

function unRegisterReducer(name) {
  delete _reducers[name];

  if (_emitChange) {
    _emitChange(getReducers());
  }
}

function setChangeListener(listener) {
  _emitChange = listener;
}